import { defineMessages } from 'react-intl';

export default defineMessages({
  manageAlerts: {
    id: 'global_notifications_manage_cta_serp',
    defaultMessage: 'Manage my email alerts',
  },
});



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/CallToActionLink/messages.js